var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fm-checkbox",class:_vm.checkboxClass,on:{"click":_vm.toggle}},[_c('i'),(_vm.$slots.default)?[_vm._t("default")]:[_vm._v(_vm._s(_vm.label))],_c('input',{attrs:{"type":"hidden","name":_vm.label,"disabled":_vm.disabled !== false},domProps:{"value":_vm.value}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }